import { useApi, SKY_API_ENDPOINT } from '@/api';
import { KpiSkeleton, TableSkeleton, Flex } from '@blockanalitica/ui';
import { Page, KpiCard } from '@/components';
import StarASCTable from './StarASCTable';
import { useParams } from 'react-router-dom';
export default function StarASCPage() {
  const { star } = useParams();
  const [response, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: `/asc/primes/${star}/`
  });

  if (error) {
    throw error;
  }

  const data = response?.data;
  if (!data) {
    return (
      <Flex flexDirection="column" gap="s">
        <Flex gap="xs" flexDirection={['column', 'row']}>
          <KpiSkeleton />
          <KpiSkeleton />
          <KpiSkeleton />
        </Flex>
        <TableSkeleton rows={5} columns={4} />
      </Flex>
    );
  }

  return (
    <Page title={`${star.charAt(0).toUpperCase() + star.slice(1)} ASC`}>
      <Flex gap="xs" flexDirection={['column', 'row']}>
        <KpiCard
          title="Resting ASC"
          data={data}
          field="resting_asc"
          options={{ currency: 'USD', notation: 'compact' }}
        />
        <KpiCard
          title="Latent ASC"
          data={data}
          field="latent_asc"
          options={{ currency: 'USD', notation: 'compact' }}
        />

        <KpiCard
          title="Total ASC"
          data={data}
          field="total_asc"
          options={{ currency: 'USD', notation: 'compact' }}
        />
      </Flex>
      <StarASCTable />
    </Page>
  );
}
